import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { IOfficeField } from '@pages/office/models/office-data.model';
import { RequiredValidator } from './required.validator';
import { NumericRangeValidator } from './numeric-range.validator';
import { NumberMinMaxValidator } from './number-min-max.validator';
import { PercentInputValidator } from './percent-input.validator';

export class OfficeToolsValidators {
  static required(control: AbstractControl): ValidationErrors | null {
    return RequiredValidator.validate(control);
  }
  static numericRange(field: IOfficeField): ValidatorFn {
    return NumericRangeValidator.validate({ field });
  }

  static numberMinMax(field: IOfficeField): ValidatorFn {
    return NumberMinMaxValidator.validate({ field });
  }

  static percent(): ValidatorFn {
    return PercentInputValidator.validate();
  }
}
